import { render } from "./ChangeUserPassword.vue?vue&type=template&id=44906073&scoped=true"
import script from "./ChangeUserPassword.vue?vue&type=script&lang=js"
export * from "./ChangeUserPassword.vue?vue&type=script&lang=js"

import "./ChangeUserPassword.vue?vue&type=style&index=0&id=44906073&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44906073"]])

export default __exports__